import { Box, Grid, TextField, Radio, RadioGroup, FormControlLabel, FormControl, Select, MenuItem, Checkbox, ListItemText, Typography, Button, IconButton, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, InputAdornment, Divider, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MedicineDoses, { MedicineDose } from '../../../../OPD/add-patient-record/MedicineDoses';
import { Delete as DeleteIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import DynamicTable from '../../../../Dynamic-table';
import { isDateTimeGreaterThan30MinutesAgo } from '../../../../../utils/dateTimeUtils';
import { v4 as uuidv4 } from 'uuid';  // Import uuid package
import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import LinkCrossMatchDialog, { LinkedCrossMatchReport, fetchCrossMatchById } from '../LinkCrossMatchDialog';
import { generateCrossMatchPDF } from '../../../../../pages/blood-donor/blood-crossmatch/cross-match-report/generateCrossMatchPDF';

const DRAFT_TRANSFUSION_INDEX = -1;

interface TreatmentProps {
    onChange: (data: any) => void;
    data: any;
    otherTabsData: any;
    profile: any;
    opdData: any
}

interface FormData {
    guidance: string;
    medicines: MedicineDose[];
    transfusion: any;
    createdAt?: string
    med_doc?: any
}

const components = [
    { value: 'PRBC', label: 'PRBC' },
    { value: 'FFP', label: 'FFP' },
    { value: 'Platelets', label: 'Platelets' },
    { value: 'Cryoprecipitate', label: 'Cryoprecipitate' },
    { value: 'Whole Blood', label: 'Whole Blood' },
];
interface DeletedMedicine {
    medicine: MedicineDose;
    deletedTime: string;
    deletedBy: string;
}
const Treatment: React.FC<TreatmentProps> = ({ onChange, data, otherTabsData, profile, opdData }) => {
    const currentDate = dayjs();
    const [isMultiline, setIsMultiline] = useState(false);
    const [medicineData, setMedicineData] = useState<MedicineDose[]>([]);
    const [formData, setFormData] = useState<FormData>({
        guidance: '',
        medicines: [],
        transfusion: {
            bloodTransfusion: 'Arrange',
            components: [],
            pint: '',
            quantity: '',
            checkedByDoctor: false,
            crossMatch: undefined as LinkedCrossMatchReport | undefined,
        },
        createdAt: '',
        med_doc: null
    });
    const [guidances, setGuidances] = useState<any[]>([]); 
    const [isMultiline1, setIsMultiline1] = useState(false);
    
    const [savedTransfusions, setSavedTransfusions] = useState<any[]>([]);
    const [deletedMedicines, setDeletedMedicines] = useState<DeletedMedicine[]>([]);
    const [isBloodTransfusionChecked, setIsBloodTransfusionChecked] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
    const [linkCrossMatchOpen, setLinkCrossMatchOpen] = useState(false);
    const [linkingTransfusionIndex, setLinkingTransfusionIndex] = useState<number | null>(null);
    const projectProfile = useSelector((state: any) => state.projectProfileSlice?.projectProfile);
    const hospitalName = projectProfile?.hospitalName || 'N/A';

    const handleAddGuidance = () => {
        setGuidances((prevGuidances) => [
            ...prevGuidances,
            { guidance: '', doctor_Name: profile?.data?.fullName, date_Time: dayjs() },
        ]);
    };
    const handleDeleteGuidance = (index: any) => {
        setGuidances((prevGuidances) => prevGuidances?.filter((_, i) => i !== index));
    };

    const handleGuidanceChange = (index: number, value: string) => {
        const updatedGuidances = [...guidances];
        updatedGuidances[index].guidance = value;
        setGuidances(updatedGuidances);
    };
    const handleFocus1 = (index: number) => {
        setFocusedIndex(index); 
        setIsMultiline1(true); 
    };

    const handleBlur1 = () => {
        setFocusedIndex(null); 
        setIsMultiline1(false); 
    };

    const handleCheckboxChange = (event: any) => {
        setIsBloodTransfusionChecked(event.target.checked);
    };
    const handleBlur = () => setIsMultiline(false);
    const handleFocus = () => setIsMultiline(true);

    const handleDeleteTransfusion = (indexToDelete: number) => {
        setSavedTransfusions((prev: any[]) => {
            if (Array.isArray(prev)) {
                return prev?.filter((_, index) => index !== indexToDelete);
            }
            return [];
        });
    };

    const handleMedicineDoses = (medicineDoses: MedicineDose[], deletedInfo?: { medicine: MedicineDose; deletedTime: string; deletedBy: string }) => {
        if (deletedInfo) {
            setDeletedMedicines((prev: any) => {
                return Array.isArray(prev) ? [...prev, deletedInfo] : [deletedInfo];
            });
        }
        const updatedFormData: any = {
            ...formData,
            medicines: medicineDoses,
        };
        setFormData(updatedFormData);
    };
    useEffect(() => {
        onChange({
            medicines: formData.medicines,
            guidance: formData?.guidance,
            guidances,
            transfusion: savedTransfusions,
            created_By: formData?.med_doc,
            created_At: formData?.createdAt,
        });
    }, [formData, savedTransfusions, guidances]);

    useEffect(() => {
        const savedMedicines = Array.isArray(data?.medicines) ? data.medicines : [];
        const hasSavedMedicines = savedMedicines.length > 0;
        const lastPrescriptionMedicines = Array.isArray(opdData?.medicines) ? opdData.medicines : [];

        if (hasSavedMedicines) {
            setFormData((prev) => ({
                ...prev,
                guidance: data?.guidance || '',
                medicines: savedMedicines,
                med_doc: data?.created_By,
                createdAt: data?.created_At
            }));
            setMedicineData(savedMedicines);
        } else if (lastPrescriptionMedicines.length > 0) {
            setMedicineData(lastPrescriptionMedicines);
            setFormData((prev) => ({
                ...prev,
                guidance: opdData?.guidance || '',
                medicines: lastPrescriptionMedicines,
                med_doc: opdData?.doctor?.fullName,
                createdAt: opdData?.createdAt
            }));
        } else if (data) {
            setFormData((prev) => ({
                ...prev,
                guidance: data?.guidance || '',
                medicines: [],
                med_doc: data?.created_By,
                createdAt: data?.created_At
            }));
            setMedicineData([]);
        }

        if (data?.transfusion) {
            setSavedTransfusions(Array.isArray(data?.transfusion) ? data?.transfusion : []);
        }
        if (data?.guidances) {
            setGuidances(data?.guidances);
        }
        if (data?.deletedMedicines) {
            setDeletedMedicines(data?.deletedMedicines);
        }
    }, [data, opdData]);

    const buildCrossMatchLink = (item: any): LinkedCrossMatchReport => ({
        crossMatchId: item?._id,
        slipNo: item?.slipNo,
        bagNo: item?.bagNo,
        bloodGroup: `${item?.slipData?.bloodGroup || ''}${item?.slipData?.rhFactor || ''}`.trim(),
        component: item?.bagData?.componentName || item?.componentName || '',
        crossMatchResult: item?.crossMatchResult || '',
        crossMatchDate: item?.crossMatchDate || item?.createdAt,
        performedBy: item?.performedBy || '',
        linkedAt: dayjs().format('DD.MM.YYYY hh:mm A'),
        linkedBy: profile?.data?.fullName,
    });

    const openLinkCrossMatchForDraft = () => {
        setLinkingTransfusionIndex(DRAFT_TRANSFUSION_INDEX);
        setLinkCrossMatchOpen(true);
    };

    const openLinkCrossMatchForRow = (rowIndex: number) => {
        setLinkingTransfusionIndex(rowIndex);
        setLinkCrossMatchOpen(true);
    };

    const handleLinkCrossMatch = (item: any) => {
        if (linkingTransfusionIndex === null) return;
        const linked = buildCrossMatchLink(item);
        if (linkingTransfusionIndex === DRAFT_TRANSFUSION_INDEX) {
            setFormData((prev) => ({
                ...prev,
                transfusion: {
                    ...prev.transfusion,
                    crossMatch: linked,
                },
            }));
        } else {
            setSavedTransfusions((prev) =>
                prev.map((row, index) =>
                    index === linkingTransfusionIndex
                        ? { ...row, crossMatch: linked }
                        : row
                )
            );
        }
        toast.success(`Cross match Slip# ${item?.slipNo} linked to transfusion.`);
    };

    const handleUnlinkCrossMatch = () => {
        if (linkingTransfusionIndex === null) return;
        if (linkingTransfusionIndex === DRAFT_TRANSFUSION_INDEX) {
            setFormData((prev) => ({
                ...prev,
                transfusion: {
                    ...prev.transfusion,
                    crossMatch: undefined,
                },
            }));
        } else {
            setSavedTransfusions((prev) =>
                prev.map((row, index) =>
                    index === linkingTransfusionIndex
                        ? { ...row, crossMatch: undefined }
                        : row
                )
            );
        }
        toast.success('Cross match report unlinked.');
    };

    const handleClearDraftCrossMatch = () => {
        setFormData((prev) => ({
            ...prev,
            transfusion: {
                ...prev.transfusion,
                crossMatch: undefined,
            },
        }));
    };

    const handleUnlinkCrossMatchFromRow = (rowIndex: number) => {
        setSavedTransfusions(prev =>
            prev.map((row, index) =>
                index === rowIndex ? { ...row, crossMatch: undefined } : row
            )
        );
        toast.success('Cross match report unlinked.');
    };

    const handleViewCrossMatch = async (report?: LinkedCrossMatchReport) => {
        if (!report?.crossMatchId) {
            toast.info('No cross match linked to this transfusion.');
            return;
        }
        try {
            const crossMatch = await fetchCrossMatchById(report.crossMatchId);
            if (!crossMatch) {
                toast.error('Cross match report not found.');
                return;
            }
            const formatDate = (date: string) =>
                date ? dayjs(date).format('DD.MM.YYYY') : '-';
            const doc = generateCrossMatchPDF(
                crossMatch,
                formatDate,
                crossMatch?.performedBy || profile?.data?.fullName || '',
                hospitalName
            );
            if (!doc) {
                toast.error('Failed to generate cross match report.');
                return;
            }
            const blobUrl = URL.createObjectURL(doc.output('blob'));
            window.open(blobUrl, '_blank');
        } catch (error: any) {
            toast.error(error?.response?.data?.message || 'Failed to load cross match report.');
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any, fieldName?: string) => {
        if (e?.target) {
            const { name, value } = e.target;
            if (name === "guidance") {
                setFormData(prevState => {
                    const updatedFormData = {
                        ...prevState,
                        guidance: value,
                    };
                    return updatedFormData;
                });
            } else if (fieldName) {
                setFormData(prevState => {
                    const updatedFormData = {
                        ...prevState,
                        transfusion: {
                            ...prevState.transfusion,
                            [fieldName]: value,
                        },
                    };
                    return updatedFormData;
                });
            } else {
                setFormData(prevState => {
                    const updatedFormData = {
                        ...prevState,
                        [name]: value,
                    };
                    return updatedFormData;
                });
            }
        }
    };

    const handleComponentChange = (event: any) => {
        const { value } = event.target;
        const updatedComponents = Array.isArray(value) ? value : value?.split(',');
        setFormData((prevState) => {
            const updatedFormData = {
                ...prevState,
                transfusion: {
                    ...prevState.transfusion,
                    components: updatedComponents,
                },
            };
            return updatedFormData;
        });
    };

    const isComponentDisabled = (component: string) => {
        if (formData?.transfusion?.components?.includes('Whole Blood')) {
            return component !== 'Whole Blood';
        } else {
            return component === 'Whole Blood' && formData?.transfusion?.components?.length > 0;
        }
    };

    const removeTransfusionField = () => {
        setFormData((prevData: any) => ({
            ...prevData,
            transfusion: {
                bloodTransfusion: 'Arrange',
                components: [],
                pint: '',
                quantity: '',
                checkedByDoctor: false,
                crossMatch: undefined,
            },
        }));
    };

    const handleCheckedByDoctorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData((prev) => ({
            ...prev,
            transfusion: {
                ...prev.transfusion,
                checkedByDoctor: event.target.checked,
            },
        }));
    };

    const handleSaveTransfusions = () => {
        const newTransfusion = {
            ...formData.transfusion,
            id: uuidv4(),
            dateTime: currentDate.format('DD.MM.YYYY hh:mm A'),
            doctorName: profile?.data?.fullName,
        };
        setSavedTransfusions((prev: any) => [...prev, newTransfusion]);
        removeTransfusionField();
        setIsBloodTransfusionChecked(false);
    };

    return (
        <Box mt={0.5}>
            <Grid container spacing={1}>
                <Grid item md={3} sm={4} xs={6}>
                    <TextField
                        size="small"
                        placeholder="OPD Guidance"
                        variant="outlined"
                        fullWidth
                        label='OPD Guidance'
                        name="guidance"
                        // disabled
                        value={formData?.guidance}
                        InputProps={{
                            style: {
                                borderRadius: "12px",
                                background: "#F5F5FB",
                                fontSize: "12px",
                            },
                        }}

                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    border: "none",
                                },
                                "&:hover fieldset": {
                                    border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "none",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                top: "-2px",
                            },
                        }}
                        // onChange={handleChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        multiline={isMultiline}
                        minRows={isMultiline ? 3 : 1}
                    />
                    <Box >
                        <Typography variant="body2" color="textSecondary" sx={{ fontSize: '10px' }}>
                            {formData?.med_doc} | {dayjs(formData?.createdAt).format('DD.MM.YYYY hh:mm A')}
                        </Typography>
                    </Box>
                </Grid>
                {guidances?.map((guidance, index) => (
                    <Grid item md={2.8} sm={4} xs={6} key={index}>
                        <Box sx={{ position: 'relative' }}>
                            <TextField
                                size="small"
                                placeholder="Treatment Guidance"
                                variant="outlined"
                                fullWidth
                                label="Treatment Guidance"
                                value={guidance?.guidance}
                                onChange={(e) => {
                                    if (guidance?.doctor_Name === profile?.data?.fullName) {
                                        if (!isDateTimeGreaterThan30MinutesAgo(dayjs(guidance?.date_Time).format('DD.MM.YYYY hh:mm A'))) {
                                            return;
                                        }
                                        handleGuidanceChange(index, e.target.value);
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        borderRadius: '12px',
                                        background: '#F5F5FB',
                                        fontSize: '11px',
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '&:hover fieldset': {
                                            border: 'none',
                                        },
                                        '&.Mui-focused fieldset': {
                                            border: 'none',
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        top: '-2px',
                                    },
                                }}
                                multiline={focusedIndex === index ? true : false}
                                minRows={focusedIndex === index ? 3 : 1}
                                onFocus={() => handleFocus1(index)}
                                onBlur={handleBlur1}
                            />
                            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '10px' }}>
                                {guidance?.doctor_Name} | {dayjs(guidance?.date_Time).format('DD.MM.YYYY hh:mm A')}
                            </Typography>
                            <Tooltip title='Delete Guidance' placement='top'>
                                <IconButton
                                    sx={{ position: 'absolute', top: '-8px', right: '-4px', background: 'gray', color: '#000', width: '12px', height: '14px', }}
                                    onClick={() => handleDeleteGuidance(index)}
                                    disabled={guidance?.doctor_Name !== profile?.data?.fullName || !isDateTimeGreaterThan30MinutesAgo(dayjs(guidance?.date_Time).format('DD.MM.YYYY hh:mm A'))}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Grid>
                ))}
                <Grid item md={.2} sm={4} xs={6}>
                    <Box display='flex' justifyContent='center'>
                        <Tooltip title='Add More' placement='top'>
                            <Button
                                sx={{ padding: '0px', minWidth: '10px', mt: 1 }}
                                onClick={handleAddGuidance}
                                size='small'
                            >
                                +
                            </Button>
                        </Tooltip>
                    </Box>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item md={12} sm={12} xs={12} sx={{ mt: 1, mb: 1 }}>
                    <MedicineDoses
                        onMedicineDoses={handleMedicineDoses}
                        medicineDataIfExist={medicineData}
                        setMedicineData={setMedicineData}
                        medicineData={medicineData}
                        treatment={true}
                    />
                </Grid>
            </Grid>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>Blood Transfusion</Typography>
                <Checkbox
                    checked={isBloodTransfusionChecked}
                    onChange={handleCheckboxChange}
                    size='small'
                />
            </Box>
            {
                isBloodTransfusionChecked && (<Grid container spacing={1} >
                    <Grid item md={3}>
                        <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>Transfusion</Typography>
                        <FormControl component="fieldset">
                            <RadioGroup
                                row
                                name="bloodTransfusion"
                                value={formData?.transfusion?.bloodTransfusion}
                                onChange={(e) => handleChange(e, 'bloodTransfusion')}
                                sx={{
                                    fontSize: '12px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <FormControlLabel
                                    value="Arrange"
                                    control={<Radio size='small' sx={{ fontSize: '12px' }} />}
                                    label="Arrange"
                                    sx={{
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                />
                                <FormControlLabel
                                    value="Transfuse"
                                    control={<Radio size='small' sx={{ fontSize: '12px' }} />}
                                    label="Transfuse"
                                    sx={{
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {formData?.transfusion?.bloodTransfusion === "Arrange" && <Grid item md={1.5} sm={3} xs={4}>
                        <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>Pint</Typography>
                        <TextField
                            placeholder="Pint"
                            variant="outlined"
                            size="small"
                            value={formData?.transfusion?.pint || ''}
                            onChange={(e) => handleChange(e, 'pint')}
                            className='search-field'
                            type='number'
                            InputProps={{
                                endAdornment: <InputAdornment position="end">pint</InputAdornment>,
                            }}
                        />
                    </Grid>}
                    {formData?.transfusion?.bloodTransfusion === "Transfuse" && <Grid item md={1.5} sm={3} xs={4}>
                        <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>Quantity</Typography>
                        <TextField
                            placeholder="Quantity"
                            variant="outlined"
                            size="small"
                            value={formData?.transfusion?.quantity || ''}
                            onChange={(e) => handleChange(e, 'quantity')}
                            className='search-field'
                            type='number'
                            InputProps={{
                                endAdornment: <InputAdornment position="end">ml</InputAdornment>,
                            }}
                        />
                    </Grid>}
                    <Grid item md={2} sm={3} xs={4}>
                        <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>Components</Typography>
                        <Select
                            multiple
                            name="components"
                            value={formData?.transfusion?.components || []}
                            onChange={handleComponentChange}
                            fullWidth
                            size="small"
                            renderValue={(selected) => selected?.join(', ')}
                            sx={{
                                // height: '38px',
                                borderRadius: "12px",
                                background: "#F5F5FB",
                                fontSize: "12px",
                                boxShadow: "none",
                                "& fieldset": { border: "none" },
                                padding: '2px'
                            }}
                        >
                            {components?.map((component) => (
                                <MenuItem key={component?.value} value={component?.value} disabled={isComponentDisabled(component?.value)} sx={{ padding: '2px' }}>
                                    <Checkbox size='small' checked={formData?.transfusion?.components?.includes(component?.value)} />
                                    <ListItemText primary={component?.label} />
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item md={2.5} sm={4} xs={6} sx={{ mt: 2 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={!!formData?.transfusion?.checkedByDoctor}
                                    onChange={handleCheckedByDoctorChange}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                    Checked by doctor
                                </Typography>
                            }
                        />
                    </Grid>

                    <Grid item xs />

                    <Grid item md="auto" sm={6} xs={12} sx={{ mt: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
                            <Tooltip
                                title={
                                    formData?.transfusion?.crossMatch?.slipNo
                                        ? `Linked Slip# ${formData.transfusion.crossMatch.slipNo}`
                                        : 'Link cross match report'
                                }
                            >
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<LinkIcon />}
                                    onClick={openLinkCrossMatchForDraft}
                                >
                                    {formData?.transfusion?.crossMatch
                                        ? `Slip# ${formData.transfusion.crossMatch.slipNo}`
                                        : 'Link Cross Match'}
                                </Button>
                            </Tooltip>
                            {formData?.transfusion?.crossMatch && (
                                <>
                                    <Tooltip title="View Cross Match">
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                handleViewCrossMatch(formData?.transfusion?.crossMatch)
                                            }
                                        >
                                            <VisibilityIcon fontSize="small" sx={{ color: '#1976D2' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Unlink Cross Match">
                                        <IconButton size="small" onClick={handleClearDraftCrossMatch}>
                                            <LinkOffIcon fontSize="small" sx={{ color: '#FF5454' }} />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            )}
                            <Button
                                size="small"
                                variant="contained"
                                disabled={
                                    !(formData?.transfusion?.components && formData?.transfusion?.pint) &&
                                    !(formData?.transfusion?.quantity && formData?.transfusion?.components)
                                }
                                onClick={handleSaveTransfusions}
                            >
                                Save
                            </Button>
                        </Box>
                    </Grid>
                </Grid>)
            }
            <Box mt={1}>
                <DynamicTable
                    headers={[
                        "SN", "Blood Transfusion", "Pint", "Quantity", "Components",
                        "Checked by Doctor", "Cross Match",
                        "Doctor Name", "Date & Time", "Action"
                    ]}
                    data={savedTransfusions?.map((transfusion: any, index: any) => [
                        index + 1,
                        transfusion?.bloodTransfusion,
                        transfusion?.pint,
                        `${transfusion?.quantity || ''} ${transfusion?.quantity ? "ml" : "-"}`,
                        transfusion?.components?.join(', '),
                        transfusion?.checkedByDoctor ? 'Yes' : 'No',
                        transfusion?.crossMatch?.slipNo
                            ? `Slip# ${transfusion.crossMatch.slipNo}${transfusion.crossMatch.crossMatchResult ? ` (${transfusion.crossMatch.crossMatchResult})` : ''}`
                            : 'Not linked',
                        transfusion?.doctorName,
                        transfusion?.dateTime,
                    ])}
                    actionButtons={[
                        {
                            icon: (rowIndex: number) => (
                                <Tooltip title={savedTransfusions[rowIndex]?.crossMatch ? "Change Cross Match" : "Link Cross Match"}>
                                    <LinkIcon
                                        sx={{
                                            color: savedTransfusions[rowIndex]?.crossMatch ? "#00897B" : "#1976D2",
                                            height: '20px',
                                        }}
                                    />
                                </Tooltip>
                            ),
                            onClick: (rowIndex: number) => openLinkCrossMatchForRow(rowIndex),
                        },
                        {
                            icon: (rowIndex: number) => (
                                <Tooltip title="View Cross Match">
                                    <VisibilityIcon
                                        sx={{
                                            color: savedTransfusions[rowIndex]?.crossMatch ? "#1976D2" : "#BDBDBD",
                                            height: '20px',
                                        }}
                                    />
                                </Tooltip>
                            ),
                            onClick: (rowIndex: number) =>
                                handleViewCrossMatch(savedTransfusions[rowIndex]?.crossMatch),
                            disabled: (rowIndex: number) => !savedTransfusions[rowIndex]?.crossMatch,
                        },
                        {
                            icon: (rowIndex: number) => (
                                <Tooltip title="Unlink Cross Match">
                                    <LinkOffIcon
                                        sx={{
                                            color: savedTransfusions[rowIndex]?.crossMatch ? "#FF5454" : "#BDBDBD",
                                            height: '20px',
                                        }}
                                    />
                                </Tooltip>
                            ),
                            onClick: (rowIndex: number) => handleUnlinkCrossMatchFromRow(rowIndex),
                            disabled: (rowIndex: number) => !savedTransfusions[rowIndex]?.crossMatch,
                        },
                        {
                            icon: (rowIndex: number) => (
                                <DeleteIcon
                                    sx={{
                                        color: isDateTimeGreaterThan30MinutesAgo(savedTransfusions[rowIndex]?.dateTime) ? "#FF5454" : "#D3D3D3",
                                        "&:hover": {
                                            background: "none",
                                            color: isDateTimeGreaterThan30MinutesAgo(savedTransfusions[rowIndex]?.dateTime) ? "rgb(191, 44, 44)" : "#D3D3D3",
                                        },
                                        height: '20px'
                                    }}
                                />
                            ),
                            onClick: (rowIndex: number) => handleDeleteTransfusion(rowIndex),
                        },
                    ]}
                />
            </Box>

            <LinkCrossMatchDialog
                open={linkCrossMatchOpen}
                onClose={() => {
                    setLinkCrossMatchOpen(false);
                    setLinkingTransfusionIndex(null);
                }}
                mrn={otherTabsData?.patientData?.mrn}
                linkedReports={
                    linkingTransfusionIndex === DRAFT_TRANSFUSION_INDEX && formData?.transfusion?.crossMatch
                        ? [formData.transfusion.crossMatch]
                        : linkingTransfusionIndex !== null &&
                          linkingTransfusionIndex >= 0 &&
                          savedTransfusions[linkingTransfusionIndex]?.crossMatch
                        ? [savedTransfusions[linkingTransfusionIndex].crossMatch]
                        : []
                }
                usedByOtherIds={savedTransfusions
                    .filter((_, index) => index !== linkingTransfusionIndex)
                    .map((row) => row?.crossMatch?.crossMatchId)
                    .filter(Boolean)
                    .concat(
                        linkingTransfusionIndex !== DRAFT_TRANSFUSION_INDEX &&
                            formData?.transfusion?.crossMatch?.crossMatchId
                            ? [formData.transfusion.crossMatch.crossMatchId]
                            : []
                    )}
                onLink={handleLinkCrossMatch}
                onUnlink={handleUnlinkCrossMatch}
                singleSelect
            />
        </Box >
    );
};

export default Treatment;

